/* global __webpack_public_path__ */
/* eslint-disable no-global-assign */
const getScriptSource = () => {
  const currentScript = document.currentScript;
  if (currentScript && currentScript.src) {
    return currentScript.src;
  }

  const scripts = document.getElementsByTagName('script');
  if (!scripts.length) {
    return '';
  }

  return scripts[scripts.length - 1].src || '';
};

const getPublicPath = (scriptSrc) => {
  if (!scriptSrc) {
    return '';
  }

  const scriptUrl = new URL(scriptSrc, window.location.href);
  const match = scriptUrl.pathname.match(/^(.*)\/static\/js\/[^/]+$/);
  if (!match) {
    return '';
  }

  const basePath = match[1];
  return basePath.endsWith('/') ? basePath : `${basePath}/`;
};

const publicPath = getPublicPath(getScriptSource());
if (publicPath) {
  __webpack_public_path__ = publicPath;
}
